import { render, staticRenderFns } from "./purchase.vue?vue&type=template&id=55abbc6e&scoped=true&"
import script from "./purchase.vue?vue&type=script&lang=js&"
export * from "./purchase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55abbc6e",
  null
  
)

export default component.exports